<div class="overflow-auto p-5" style="height: 75vh">
  <div class="flex flex-col w-full">
    <div class="inline-block min-w-full pb-2 align-middle">
      <table class="min-w-full">
        <thead class="border-b border-gray-400">
          <tr>
            <th scope="col" class="px-6 py-3 pl-0 font-bold tracking-wider text-left uppercase text-chathams-blue">
              Nome
            </th>
            <th scope="col" class="px-6 py-3 font-bold tracking-wider text-left uppercase text-chathams-blue">
              Código
            </th>
            <th scope="col" class="px-6 py-3 font-bold tracking-wider text-left uppercase text-chathams-blue">CNPJ</th>

            <th
              scope="col"
              class="px-6 py-3 font-bold tracking-wider text-center uppercase text-chathams-blue"
              *isAllowed="[ERoleAdminString.Admin, 'subsidiary.update']"
            >
              Mais
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="bg-white hover:bg-iceberg" *ngFor="let filial of filiais">
            <td class="px-6 py-4 pl-0 font-medium text-md text-chathams-blue whitespace-nowrap">
              {{ filial.name }}
            </td>
            <td class="px-6 py-4 font-medium leading-4 tracking-wider text-md text-chathams-blue whitespace-nowrap">
              {{ filial.code }}
            </td>
            <td class="px-6 py-4 font-medium leading-4 tracking-wider text-md text-chathams-blue whitespace-nowrap">
              {{ filial.document | mask: '00.000.000/0000-00' }}
            </td>

            <td
              class="flex justify-center flex-1 gap-2 px-6 py-4 whitespace-normal text-md text-chathams-blue"
              *isAllowed="[ERoleAdminString.Admin, 'subsidiary.update']"
            >
              <button
                class="flex items-center justify-center w-8 h-8 rounded-full bg-iceberg"
                [routerLink]="'editar/' + filial.id"
                (click)="abrirEmNovaAba(filial.id!)"
                title="Editar Filiais"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="#000000"
                  width="20"
                  height="20"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                  />
                </svg>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="flex justify-end mb-5">
      <app-paginacao
        [numeroDeItens]="dadosPaginacaoFiliais.itensTotal"
        [tamanhoDaPagina]="dadosPaginacaoFiliais.tamanhoPagina"
        [paginaSelecionada]="dadosPaginacaoFiliais.paginaSelecionada"
        [totalPage]="dadosPaginacaoFiliais.totalPaginas"
        [opcaoItensPagina]="[4, 8]"
        (mudouPagina)="mudouPagina.emit($event)"
        (mudouTamanhoPagina)="mudouTamanhoPagina.emit($event)"
      ></app-paginacao>
    </div>
  </div>

  <app-add-new-filiais (recarregarListagem)="recarregarListagem.emit()" [companyId]="companyId"></app-add-new-filiais>
</div>
